module.exports = __webpack_public_path__ + "static/media/manual.9323ba4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/manual.png
// module id = 1059
// module chunks = 0